import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CatFaqModel } from "@tCentro/Services/CENCatFAQService";

import CatFaqState from "@tCentro/Store/Reducer/CatFaqState";

const initialState: CatFaqState = {
    faqs: [],
    isLoading: false,
};

export default createTypedReducerWithImmer(initialState, {
    "Custom/FaqData/BeginCatLoad": (draft: CatFaqState, action: { categoryId: string }) => {
        draft.isLoading = true;
        draft.categoryId = action.categoryId;
        draft.faqs = [];
    },
    "Custom/Faq/CompletedCatLoad": (
        draft: CatFaqState,
        action: {
            categoryId: string;
            result: CatFaqModel[];
        },
    ) => {
        draft.faqs = action.result;
        draft.isLoading = false;
        draft.categoryId = action.categoryId;
    },
});
